import React from 'react'
import { useGetTNMReports } from './hooks'
import { GridColDef } from '@mui/x-data-grid-pro'
import DataList from '../../../components/DataList'
import { useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { convertUTCToTZ, guessUserTZ } from '../../../lib/time'
import { checkUserRoles } from '../../../lib/rolesAndPermissions'

export const TNMReportsList = (props: any) => {
  const { id } = props
  const queryKey = ['tnmreports', id]
  const [settings] = useLocalStorage('settings', '')
  const userTZ = settings.timeZone ? settings.timeZone : guessUserTZ()
  const navigate = useNavigate()
  const toolBarConfig = {
    upload: false,
    add: true,
    export: true,
  }

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'displayReportNumber', headerName: 'Report Number', width: 130 },
    {
      field: 'createdAt',
      headerName: 'Date',
      flex: 1,
      width: 130,
      valueGetter: params => {
        return convertUTCToTZ(params.row.date, userTZ)
      },
    },
  ]

  return (
    <>
      <DataList
        columns={columns}
        user={null}
        queryKey={queryKey}
        useGetItems={useGetTNMReports}
        toolBarItems={toolBarConfig}
        addAction={() => navigate('report/new')}
        includeRowEdit={false}
        includeRowDelete={false}
        viewLink={'report'}
        enableBulkActions={false}
        checkboxSelection={false}
      />
    </>
  )
}
